var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "article",
    {
      staticClass: "lpu-review-card d-flex",
      class: [
        _setup.cardClasses,
        _setup.isMobile ? "flex-column ga-3 py-6" : "align-start pa-8",
      ],
      attrs: {
        id: `rate-${_vm.rate.id}`,
        "data-qa": "review_card",
        "data-review-id": _vm.rate.id,
        "data-review-type":
          _vm.rate.rate_type || (_vm.rate.doctor ? "doctor" : "lpu"),
        "data-review-is-deleted": _vm.rate.is_deleted ? "true" : "false",
        "data-year": _setup.year,
        itemprop: "review",
        itemscope: "",
        itemtype: "https://schema.org/Review",
      },
    },
    [
      _c(_setup.ReviewCardMeta, {
        attrs: { rate: _vm.rate, lpu: _vm.lpu },
        on: {
          "open-author": function ($event) {
            return _vm.$emit("open-author", $event)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "lpu-review-card__body",
          attrs: {
            itemprop: "reviewBody",
            data: `1${_vm.rate.id}`,
            "data-rtype": _vm.rate.ratetype,
          },
        },
        [
          _c(_setup.ReviewCardBody, {
            attrs: { rate: _vm.rate, lpu: _vm.lpu },
            on: {
              "open-image": function ($event) {
                return _vm.$emit("open-image", $event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }